import { maximumAllowedRolloutStageDurationMs } from '@gonfalon/dogfood-flags/dogfood-flags';

/**
 * Get the min/max limits for duration quantity based on unit.
 * The maximum is determined by a feature flag.
 */
export function getDurationQuantityLimits() {
  const stageDurationMs = maximumAllowedRolloutStageDurationMs();

  // If flag is -1 or any negative value, treat as "no maximum" (return undefined for max)
  const hasMaximum = stageDurationMs > 0;

  return {
    day: {
      min: 1,
      max: hasMaximum ? Math.max(1, Math.floor(stageDurationMs / (24 * 60 * 60 * 1000))) : undefined,
    },
    hour: {
      min: 1,
      max: hasMaximum ? Math.max(1, Math.floor(stageDurationMs / (60 * 60 * 1000))) : undefined,
    },
    minute: {
      min: 1,
      max: hasMaximum ? Math.max(1, Math.floor(stageDurationMs / (60 * 1000))) : undefined,
    },
  };
}
